<template>
  <div class="topnav">
    <img src="~@/assets/image/home/nameicon.png" alt="" style="height:55px">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="transparent" text-color='#272B34'
      active-text-color='#136BCF'>
      <template v-for="item in navlist">
        <el-menu-item :index="item.id" :key="item.id" v-if="item.children.length==0" @click="changenav(item)">{{item.name}}</el-menu-item>
        <el-submenu :index="item.id" v-else :key="item.id" popper-class="navitem">
          <template slot="title">{{item.name}}</template>
          <el-menu-item :index="e.id" :key="e.id" v-for="e in item.children" @click="changenav(e)">{{e.name}}</el-menu-item>
        </el-submenu>
      </template>
      <!-- <el-menu-item index="1">首页</el-menu-item>
      <el-submenu index="2" popper-class="navitem">
        <template slot="title">关于我们</template>
        <el-menu-item index="2-1">协会简介</el-menu-item>
        <el-menu-item index="2-2">协会章程</el-menu-item>
        <el-menu-item index="2-3">协会领导</el-menu-item>
        <el-menu-item index="2-4">组织机构</el-menu-item>
      </el-submenu>
      <el-submenu index="3" popper-class="navitem">
        <template slot="title">协会动态</template>
        <el-menu-item index="3-1">协会动态</el-menu-item>
        <el-menu-item index="3-2">寓意生活</el-menu-item>
      </el-submenu>
      <el-menu-item index="3">行业资讯</el-menu-item>
      <el-submenu index="4" popper-class="navitem">
        <template slot="title">会员专区</template>
        <el-menu-item index="4-1">会员单位</el-menu-item>
        <el-menu-item index="4-2">如何入会</el-menu-item>
        <el-menu-item index="4-3">通知公告</el-menu-item>
        <el-menu-item index="4-4">开发商注册</el-menu-item>
      </el-submenu>
      <el-submenu index="5" popper-class="navitem">
        <template slot="title">小区共建</template>
        <el-menu-item index="5-1">共建共享</el-menu-item>
        <el-menu-item index="5-2">业务交流</el-menu-item>
      </el-submenu>
      <el-menu-item index="6">联系我们</el-menu-item> -->
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '',
      value: '',
      navlist: [
        {
          id: '1',
          name: '首页',
          path: '/',
          children: []
        },
        {
          id: '2',
          name: '关于我们',
          path: '/about',
          children: [
            {
              id: '2.1',
              name: '协会简介',
              path: '/aboutinfo',

            },
            {
              id: '2.2',
              name: '协会章程',
              path: '/aboutinfo',
            },
            {
              id: '2.3',
              name: '协会领导',
              path: '/aboutinfo',
            },
            {
              id: '2.4',
              name: '组织机构',
              path: '/about',
            }
          ]
        },
        {
          id: '3',
          name: '协会动态',
          path: '/about',
          children: [
            {
              id: '3.1',
              name: '协会动态',
              path: '/about',
            },
            {
              id: '3.2',
              name: '寓意生活',
              path: '/about',
            }
          ]
        },
        {
          id: '4',
          name: '行业资讯',
          path: '/about',
          children: []
        },
        {
          id: '5',
          name: '会员专区',
          path: '/about',
          children: [
            {
              id: '5.1',
              name: '会员单位',
              path: '/about',
            },
            {
              id: '5.2',
              name: '如何入会',
              path: '/aboutinfo',
            },
            {
              id: '5.3',
              name: '通知公告',
              path: '/about',
            },
            {
              id: '5.4',
              name: '开发商注册',
              path: '/about',
            }
          ]
        },
        {
          id: '6',
          name: '共建共享',
          path: '/about',
          children: [{
            id: '6.1',
            name: '共建共享',
            path: '/about',
          }, {
            id: '6.2',
            name: '业务交流',
            path: '/about',
          },]
        },
        {
          id: '7',
          name: '联系我们',
          path: '/aboutinfo',
          children: []
        }
      ]
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    changenav(item) {
      this.$router.push({
        path: item.path,
        query: {
          type: item.id
        }
      }, () => { }, () => { })
    }
  }
}
</script>

<style>
</style>